<template>
  <div class="the-navbar__user-meta flex items-center" v-if="user && user.name">

    <div class="text-right leading-tight hidden sm:block">
      <p class="font-semibold">{{ user.name }}</p>
    </div>
    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <div class="con-img ml-3">
        <img v-if="user.picture" key="onlineImg" :src="user.picture" alt="user-img" width="30" height="30"
             class="rounded-full shadow-md cursor-pointer block" />
      </div>

      <vs-dropdown-menu class="vx-navbar-dropdown">
        <ul style="min-width: 9rem">

          <li
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="logout">
            <feather-icon icon="LogOutIcon" svgClasses="w-4 h-4" />
            <span class="ml-2">Logout</span>
          </li>
        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>

export default {
  data () {
    return {

    }
  },
  computed: {
    user() {
      return this.$store.getters['auth/user'];
    }
  },
  methods: {
    async logout () {
      // if user is logged in via auth0
      await this.$store.dispatch('auth/logout');
    }
  }
}
</script>
